import React from 'react';
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';

const selectProps = { indeterminate: isIndeterminate => isIndeterminate };

const DataTableBase = (props) => {
	return (
		<DataTable
			pagination
			sortIcon={faSort}
			direction="auto"
			fixedHeader
			fixedHeaderScrollHeight="300px"
			highlightOnHover
			persistTableHead
			pointerOnHover
			responsive
			subHeader
			subHeaderAlign="right"
			subHeaderWrap
			{...props}
		/>
	);
}

export default DataTableBase;